import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

const KakaoBubble = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M12 3C6.48 3 2 6.6 2 11.06c0 2.79 1.83 5.24 4.6 6.7l-.9 3.28c-.1.36.29.66.6.46l3.94-2.6c.58.08 1.18.12 1.76.12 5.52 0 10-3.6 10-8.06S17.52 3 12 3z" />
  </svg>
);

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [kakaoEnabled, setKakaoEnabled] = useState(false);
  const [error, setError] = useState('');

  // Preserve deep-link target across the OAuth round-trip.
  const params = new URLSearchParams(location.search);
  const returnUrl = params.get('return_url') || '/';

  useEffect(() => {
    const kErr = params.get('kakao_error');
    if (kErr) {
      const msg = ({
        invalid_state: '잘못된 접근입니다. 다시 시도해주세요.',
        token_exchange: '카카오 인증 서버 오류입니다.',
        profile_fetch: '카카오 프로필 조회에 실패했습니다.',
        no_access_token: '카카오 토큰 발급에 실패했습니다.',
        no_kakao_id: '카카오 계정 정보를 가져오지 못했습니다.',
        kakao_denied: '카카오 로그인이 취소되었습니다.',
        exception: '일시적인 오류가 발생했습니다.',
      })[kErr] || `카카오 로그인 오류: ${kErr}`;
      setError(msg);
    }
    fetch(`${API}/api/auth/kakao/config`).then((r) => r.json()).then((d) => {
      setKakaoEnabled(!!d?.enabled);
    }).catch(() => setKakaoEnabled(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const startKakao = () => {
    const url = `${API}/api/auth/kakao/start?return_url=${encodeURIComponent(returnUrl)}`;
    window.location.href = url;
  };

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/auth-callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-5xl font-black tracking-tight mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
            <span className="text-[#FF3B30]">LIVE</span>
            <span className="text-black dark:text-white">MOA</span>
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 tracking-wide" style={{ fontFamily: 'Inter, sans-serif' }}>
            모든 라이브를 한 곳에
          </p>
        </div>

        <div className="bg-white dark:bg-[#141414] border border-black/5 dark:border-white/10 rounded-lg p-8 shadow-sm">
          <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="login-title">
            로그인
          </h2>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
            라이브 커머스의 모든 것
          </p>

          {error && (
            <div className="mb-4 p-3 rounded-md bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/30 text-xs text-red-700 dark:text-red-300" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            onClick={startKakao}
            disabled={!kakaoEnabled}
            className="w-full bg-[#FEE500] hover:bg-[#F5D900] disabled:opacity-40 disabled:cursor-not-allowed text-black font-bold py-3 px-4 rounded-md transition-colors duration-200 inline-flex items-center justify-center gap-2"
            data-testid="kakao-login-button"
          >
            <KakaoBubble />
            카카오로 시작하기
          </button>

          <div className="my-4 flex items-center gap-3 text-[10px] text-gray-400">
            <span className="flex-1 h-px bg-black/10 dark:bg-white/10" />
            <span>또는</span>
            <span className="flex-1 h-px bg-black/10 dark:bg-white/10" />
          </div>

          <button
            onClick={handleGoogle}
            className="w-full bg-white dark:bg-[#1a1a1a] hover:bg-gray-50 dark:hover:bg-[#222] border border-black/10 dark:border-white/10 text-black dark:text-white font-bold py-3 px-4 rounded-md transition-colors duration-200"
            data-testid="google-login-button"
          >
            Google로 로그인
          </button>

          <div className="mt-6 pt-6 border-t border-black/5 dark:border-white/10">
            <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
              로그인하면 이용약관 및 개인정보처리방침에 동의하는 것으로 간주됩니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
